import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import activeStar from 'src/assets/img/voicealbum/sort/active_star.png'
import deactiveStar from 'src/assets/img/voicealbum/sort/deactive_star.png'

import RIcon from 'src/assets/img/gacha/R.png'
import SRIcon from 'src/assets/img/gacha/SR.png'
import SSRIcon from 'src/assets/img/gacha/SSR.png'

import playIcon from 'src/assets/img/voicealbum/sort/play.png'
import pauseIcon from 'src/assets/img/voicealbum/sort/pause.png'

export function VoiceCard({
  quantity,
  rarity,
  imgSrc,
  isFavor,
  handleFavor,
  handlePlay,
  isPlay,
  voiceLink
}) {
  const audioRef = useRef(null)

  const formatItemCount = (count) => {
    return count > 99 ? 'x99+' : `x${count}`
  }

  useEffect(() => {
    const toggleVoice = async () => {
      if (!audioRef.current) return
      try {
        if (isPlay) {
          audioRef.current.currentTime = 0
          await audioRef.current.play()
        } else {
          audioRef.current.pause()
        }
      } catch (error) {
        console.error('Playback failed:', error)
      }
    }
    toggleVoice()
  }, [isPlay])

  useEffect(() => {
    const audioEl = audioRef.current
    if (!audioEl) return

    const onEnded = () => {
      if (handlePlay) {
        handlePlay()
      }
    }

    audioEl.addEventListener('ended', onEnded)
    return () => {
      audioEl.removeEventListener('ended', onEnded)
    }
  }, [handlePlay])

  return (
    <div className="w-[157px] h-[77px] relative items-center flex justify-center font-Inter">
      <img
        src={rarity === 'ssr' ? SSRIcon : rarity === 'sr' ? SRIcon : RIcon}
        className={clsx(
          rarity === 'ssr' ? 'h-6' : rarity === 'sr' ? 'h-5' : 'h-4 ',
          rarity === 'ssr'
            ? 'h-6 absolute top-0 left-0'
            : rarity === 'sr'
              ? 'h-5 absolute top-0 left-1'
              : 'h-4 absolute top-0 left-2'
        )}
      />
      <audio ref={audioRef} className="hidden" src={voiceLink} autoPlay={true} playsInline={true} />
      <img src={imgSrc} className="h-full w-auto max-w-[157px]" />
      <div className="w-full absolute bottom-0 z-30 flex justify-between items-end">
        <button className=" right-1.5 " onClick={handleFavor}>
          <img src={isFavor ? activeStar : deactiveStar} className='w-7 h-7'/>
        </button>
        <p
          className="text-xl text-white font-extrabold w-9"
          style={{ textShadow: '1px 1px 2px black' }}
        >
          {formatItemCount(quantity)}
        </p>
      </div>
      <button
        className="absolute bottom-1/2 right-1/2 translate-x-1/2 translate-y-1/2"
        onClick={handlePlay}
      >
        <img src={isPlay ? pauseIcon : playIcon} />
      </button>
    </div>
  )
}

VoiceCard.propTypes = {
  rarity: PropTypes.string,
  imgSrc: PropTypes.string,
  isFavor: PropTypes.bool,
  isPlay: PropTypes.bool,
  voiceLink: PropTypes.string,
  handleFavor: PropTypes.func,
  handlePlay: PropTypes.func,
  quantity: PropTypes.number
}
